import { FrameName } from "../config";
import AbstractSalvageableTileEntity from "./AbstractSalvageableTileEntity";

class ShallowSeaRocksShipwreckSalvageableTileEntity extends AbstractSalvageableTileEntity {
	public static readonly frameName = FrameName.SHALLOW_SEA_ROCKS_SHIPWRECK;
}

export default ShallowSeaRocksShipwreckSalvageableTileEntity;
